export var DOMAIN_CONNECT_PRODUCT_TYPES;
(function (DOMAIN_CONNECT_PRODUCT_TYPES) {
    DOMAIN_CONNECT_PRODUCT_TYPES["FUNNELWEBSITE"] = "funnelwebsite";
    DOMAIN_CONNECT_PRODUCT_TYPES["CLIENTPORTAL"] = "clientportal";
    DOMAIN_CONNECT_PRODUCT_TYPES["EMAIL"] = "email";
    DOMAIN_CONNECT_PRODUCT_TYPES["WORDPRESS"] = "wordpress";
    DOMAIN_CONNECT_PRODUCT_TYPES["APIDOMAIN"] = "apidomain";
    DOMAIN_CONNECT_PRODUCT_TYPES["WHITELABELAPP"] = "whitelabelapp";
    DOMAIN_CONNECT_PRODUCT_TYPES["DOMAINBRANDING"] = "domainbranding";
})(DOMAIN_CONNECT_PRODUCT_TYPES || (DOMAIN_CONNECT_PRODUCT_TYPES = {}));
export var DOMAIN_CONNECT_PROVIDERS;
(function (DOMAIN_CONNECT_PROVIDERS) {
    DOMAIN_CONNECT_PROVIDERS["CLOUDFLARE"] = "cloudflare";
    DOMAIN_CONNECT_PROVIDERS["GOOGLE_DOMAIN"] = "Google Domains";
    DOMAIN_CONNECT_PROVIDERS["GO_DADDY"] = "GoDaddy";
    DOMAIN_CONNECT_PROVIDERS["IONOS"] = "IONOS";
})(DOMAIN_CONNECT_PROVIDERS || (DOMAIN_CONNECT_PROVIDERS = {}));
export var TEMPLATE_LOOKUP;
(function (TEMPLATE_LOOKUP) {
    TEMPLATE_LOOKUP["a"] = "a";
    TEMPLATE_LOOKUP["textSsl"] = "textSsl";
    TEMPLATE_LOOKUP["email"] = "email";
    TEMPLATE_LOOKUP["cname"] = "cname";
    TEMPLATE_LOOKUP["txtDynamic"] = "txtDynamic";
    TEMPLATE_LOOKUP["aCname"] = "aCname";
    TEMPLATE_LOOKUP["aTxtSsl"] = "aTxtSsl";
})(TEMPLATE_LOOKUP || (TEMPLATE_LOOKUP = {}));
